import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-etudiant',
    templateUrl: './etudiant.component.html',
    styleUrls: ['./etudiant.component.scss']
})
export class EtudiantComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);
    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville'/*, 'france'*/];

    /**
     * Chart repartition
     */
    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d} %)'
        },
        legend: {
            show: true,
            left: 'center',
            top: 'bottom',
            data: ['Enfance', 'Lycée', 'Enseignement supérieur', 'Formations']
        },
        calculable: true,
    };


    data = {
        series: []
    };

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            this.displayedColumns = ['lib', 'quartier', 'ville'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.ecole_iris[this.iris]) {
            irisData = this.favorite.ad_city.ecole_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.ecole_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.ecole_gq[this.secteur];
        }

        let root = this.favorite.ad_city.ecole;
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }

        this.data = {
            series: [
                {
                    name: 'Commerces',
                    type: 'pie',
                    radius: ['0%', '30%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        color: 'black',
                        fontSize: 20
                    },
                    color: ['#FFFFFF'],

                    data: [
                        {
                            value: Math.round(root.tot_ecole),
                            name: (Math.round(root.tot_ecole)).toString() + '\nÉtablissements\nscolaires'
                        },

                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    radius: ['55%', '80%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'inner',
                    },
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#FF5455'],
                    data: [
                        {
                            value: Math.round(root.maternelle + root.elementaire + root.college),
                            name: 'Enfance'
                        },
                        {
                            value: Math.round(root.lycee_gen_techno + root.lycee_pro + root.lycee_techniqe_etou_pro_agricole),
                            name: 'Lycée'
                        },
                        {
                            value: Math.round(root.cpge + root.ecole_inge + root.institut_universitaire
                                + root.enseign_general_sup_prive + root.enseign_sup_agricole + root.unite_de_form_et_recherche
                                + root.autre_enseign_sup + root.autre_postbac),
                            name: 'Enseignement supérieur'
                        },
                        {
                            value: Math.round(root.centre_form_agricole + root.centre_form_apprentis + root.form_apprentissage_agricole
                                + root.form_commerce + root.form_sante + root.form_sport
                                + root.greta + root.autre_form_continu), name: 'Formations'
                        }
                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    radius: ['85%', '95%'],
                    bottom: '15%',
                    label: {
                        show: false,
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5,
                    },
                    color: [],
                    data: []
                }
            ]
        };

        if (this.deviceService.isMobile()) {
            this.data.series[0].label.fontSize = 18;
        }

        // Enfance
        if (root.maternelle) {
            this.data.series[2].data.push({value: Math.round(root.maternelle), name: 'Ecoles maternelle'});
            this.data.series[2].color.push('#1F98D2');
        }

        if (root.elementaire) {
            this.data.series[2].data.push({value: Math.round(root.elementaire), name: 'Ecoles élementaires'});
            this.data.series[2].color.push('#42AFE4');
        }

        if (root.college) {
            this.data.series[2].data.push({value: Math.round(root.college), name: 'Collèges'});
            this.data.series[2].color.push('#91D5F6');
        }

        // Lycée
        if (root.lycee_gen_techno) {
            this.data.series[2].data.push({value: Math.round(root.lycee_gen_techno), name: 'Lycées d\'enseignement général et / ou technologique'});
            this.data.series[2].color.push('#418A11');
        }

        if (root.lycee_pro) {
            this.data.series[2].data.push({value: Math.round(root.lycee_pro), name: 'Lycées professionnel'});
            this.data.series[2].color.push('#5CB125');
        }

        if (root.lycee_techniqe_etou_pro_agricole) {
            this.data.series[2].data.push({value: Math.round(root.lycee_techniqe_etou_pro_agricole), name: 'Lycées technique ou/et professionnel agricole'});
            this.data.series[2].color.push('#BDED9E');
        }

        // Ecoles supérieurs
        if (root.cpge) {
            this.data.series[2].data.push({value: Math.round(root.cpge), name: 'Classe préparatoires aux grandes écoles'});
            this.data.series[2].color.push('#B27805');
        }

        if (root.ecole_inge) {
            this.data.series[2].data.push({value: Math.round(root.ecole_inge), name: 'Ecoles d\'ingénieurs'});
            this.data.series[2].color.push('#E9A00E');
        }

        if (root.institut_universitaire) {
            this.data.series[2].data.push({value: Math.round(root.institut_universitaire), name: 'Instituts universitaire'});
            this.data.series[2].color.push('#FFCA61');
        }

        if (root.enseign_general_sup_prive) {
            this.data.series[2].data.push({value: Math.round(root.enseign_general_sup_prive), name: 'Ecoles d\'enseignement général supérieur privé'});
            this.data.series[2].color.push('#FFD98C');
        }

        if (root.enseign_sup_agricole) {
            this.data.series[2].data.push({value: Math.round(root.enseign_sup_agricole), name: 'Ecoles d\'enseignement supérieur agricole'});
            this.data.series[2].color.push('#634200');
        }

        if (root.unite_de_form_et_recherche) {
            this.data.series[2].data.push({value: Math.round(root.unite_de_form_et_recherche), name: 'Unités de Formation et de Recherche'});
            this.data.series[2].color.push('#A5720D');
        }

        if (root.autre_enseign_sup) {
            this.data.series[2].data.push({value: Math.round(root.autre_enseign_sup), name: 'Autre enseignement supérieur'});
            this.data.series[2].color.push('#F9C256');
        }

        if (root.autre_postbac) {
            this.data.series[2].data.push({value: Math.round(root.autre_postbac), name: 'Autre formation post bac non universitaire'});
            this.data.series[2].color.push('#FFD889');
        }

        // Formations
        if (root.centre_form_agricole) {
            this.data.series[2].data.push({value: Math.round(root.centre_form_agricole), name: 'Centres de formation continue agricole'});
            this.data.series[2].color.push('#BE1111');
        }

        if (root.centre_form_apprentis) {
            this.data.series[2].data.push({value: Math.round(root.centre_form_apprentis), name: 'Centres de formation d\'apprentis'});
            this.data.series[2].color.push('#EB2D2D');
        }

        if (root.form_apprentissage_agricole) {
            this.data.series[2].data.push({value: Math.round(root.form_apprentissage_agricole), name: 'Centres de formation d\'apprentissage agricole'});
            this.data.series[2].color.push('#FF7777');
        }

        if (root.form_commerce) {
            this.data.series[2].data.push({value: Math.round(root.form_commerce), name: 'Formations commerce'});
            this.data.series[2].color.push('#FFA2A2');
        }

        if (root.form_sante) {
            this.data.series[2].data.push({value: Math.round(root.form_sante), name: 'Formations santé'});
            this.data.series[2].color.push('#FF5455');
        }

        if (root.form_sport) {
            this.data.series[2].data.push({value: Math.round(root.form_sport), name: 'Formations sport'});
            this.data.series[2].color.push('#E22323');
        }

        if (root.greta) {
            this.data.series[2].data.push({value: Math.round(root.greta), name: 'GRETA'});
            this.data.series[2].color.push('#FF7D7D');
        }

        if (root.autre_form_continu) {
            this.data.series[2].data.push({value: Math.round(root.autre_form_continu), name: 'Autre formation continue'});
            this.data.series[2].color.push('#FFB4B4');
        }

        this.compare = [
            {
                'lib': 'Établissements scolaires',
                'quartier': (irisData != null ? irisData.tot_ecole : '-'),
                'secteur': (secteurData != null ? secteurData.tot_ecole : '-'),
                'ville': this.favorite.ad_city.ecole.tot_ecole,
                // 'france': this.favorite.ad_city.ecole_fr.tot_ecole,
            },
            {
                'lib': 'Enfance',
                'quartier': (irisData != null ? irisData.maternelle + irisData.elementaire + irisData.college  : '-'),
                'secteur': (secteurData != null ? secteurData.maternelle + secteurData.elementaire + secteurData.college : '-'),
                'ville': this.favorite.ad_city.ecole.maternelle + this.favorite.ad_city.ecole.elementaire + this.favorite.ad_city.ecole.college,
                // 'france': this.favorite.ad_city.ecole_fr.maternelle + this.favorite.ad_city.ecole_fr.elementaire + this.favorite.ad_city.ecole_fr.college,
            },
            {
                'lib': 'Lycée',
                'quartier': (irisData != null ? irisData.lycee_gen_techno + irisData.lycee_pro + irisData.lycee_techniqe_etou_pro_agricole : '-'),
                'secteur': (secteurData != null ? secteurData.lycee_gen_techno + secteurData.lycee_pro + secteurData.lycee_techniqe_etou_pro_agricole : '-'),
                'ville': this.favorite.ad_city.ecole.lycee_gen_techno + this.favorite.ad_city.ecole.lycee_pro + this.favorite.ad_city.ecole.lycee_techniqe_etou_pro_agricole,
                // 'france': this.favorite.ad_city.ecole_fr.lycee_gen_techno + this.favorite.ad_city.ecole_fr.lycee_pro + this.favorite.ad_city.ecole_fr.lycee_techniqe_etou_pro_agricole,
            },
            {
                'lib': 'Enseignement supérieur',
                'quartier': (irisData != null ? irisData.cpge + irisData.ecole_inge + irisData.institut_universitaire + irisData.enseign_general_sup_prive + irisData.enseign_sup_agricole + irisData.unite_de_form_et_recherche + irisData.autre_enseign_sup + irisData.autre_postbac : '-'),
                'secteur': (secteurData != null ? secteurData.cpge + secteurData.ecole_inge + secteurData.institut_universitaire + secteurData.enseign_general_sup_prive + secteurData.enseign_sup_agricole + secteurData.unite_de_form_et_recherche + secteurData.autre_enseign_sup + secteurData.autre_postbac : '-'),
                'ville': this.favorite.ad_city.ecole.cpge + this.favorite.ad_city.ecole.ecole_inge + this.favorite.ad_city.ecole.institut_universitaire + this.favorite.ad_city.ecole.enseign_general_sup_prive + this.favorite.ad_city.ecole.enseign_sup_agricole + this.favorite.ad_city.ecole.unite_de_form_et_recherche + this.favorite.ad_city.ecole.autre_enseign_sup + this.favorite.ad_city.ecole.autre_postbac,
                // 'france': this.favorite.ad_city.ecole_fr.cpge + this.favorite.ad_city.ecole_fr.ecole_inge + this.favorite.ad_city.ecole_fr.institut_universitaire + this.favorite.ad_city.ecole_fr.enseign_general_sup_prive + this.favorite.ad_city.ecole_fr.enseign_sup_agricole + this.favorite.ad_city.ecole_fr.unite_de_form_et_recherche + this.favorite.ad_city.ecole_fr.autre_enseign_sup + this.favorite.ad_city.ecole_fr.autre_postbac,
            },
            {
                'lib': 'Formations',
                'quartier': (irisData != null ? irisData.centre_form_agricole + irisData.centre_form_apprentis + irisData.form_apprentissage_agricole + irisData.form_commerce + irisData.form_sante + irisData.form_sport + irisData.greta + irisData.autre_form_continu : '-'),
                'secteur': (secteurData != null ? secteurData.centre_form_agricole + secteurData.centre_form_apprentis + secteurData.form_apprentissage_agricole + secteurData.form_commerce + secteurData.form_sante + secteurData.form_sport + secteurData.greta + secteurData.autre_form_continu : '-'),
                'ville': this.favorite.ad_city.ecole.centre_form_agricole + this.favorite.ad_city.ecole.centre_form_apprentis + this.favorite.ad_city.ecole.form_apprentissage_agricole + this.favorite.ad_city.ecole.form_commerce + this.favorite.ad_city.ecole.form_sante + this.favorite.ad_city.ecole.form_sport + this.favorite.ad_city.ecole.greta + this.favorite.ad_city.ecole.autre_form_continu,
                // 'france': this.favorite.ad_city.ecole_fr.centre_form_agricole + this.favorite.ad_city.ecole_fr.centre_form_apprentis + this.favorite.ad_city.ecole_fr.form_apprentissage_agricole + this.favorite.ad_city.ecole_fr.form_commerce + this.favorite.ad_city.ecole_fr.form_sante + this.favorite.ad_city.ecole_fr.form_sport + this.favorite.ad_city.ecole_fr.greta + this.favorite.ad_city.ecole_fr.autre_form_continu,
            },
        ]
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
